export const KM_PHONE_VERIFICATION_TEST_IDS = {
    MODAL: "km-phone-verification-modal"
};
export const KM_PHONE_VERIFICATION_TEST_IDS = {
    MODAL: "km-phone-verification-modal"
};
